// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"94716452","839":"6f37f744"}[chunkId] + ".chunk.js";
};